import { QueryHookOptions } from '@apollo/client';
import { SelectOption } from '@anytag/shared-types';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, QueryallBanksArgs, useAllBanksQuery } from '@anytag/graphql';

export const useAllBankOptions = (options?: QueryHookOptions<Query, QueryallBanksArgs>) => {
  const { data, loading } = useAllBanksQuery({ fetchPolicy: 'cache-first', ...options });

  const allBanks = data?.allBanks || [];

  return {
    loading,
    allBanks,
    allBankOptions: getSelectOptions(allBanks),
    allBankNameOptions: allBanks.map<SelectOption<string>>((bank) => ({ label: bank?.name || '', value: bank?.name || '' }))
  };
};
